import { Routes as ReactRoutes, Route } from "react-router-dom";

import Product from "../Components/Product";
import Order from "../Components/Order";
import Account from "../Components/account/account";

// Note: the old ShopifyRouteSync component (Redirect.toRemote on location
// change) is no longer needed. The new App Bridge (CDN app-bridge.js) patches
// the History API and automatically propagates history.pushState() changes to
// the Shopify Admin address bar, so React Router navigation stays in sync
// out of the box.
function Routes(props) {
  const isAccepted = props.userConfig.sellerStatus === "Accepted";
  const isLoggedIn = isAccepted;

  return (
    <ReactRoutes>
      {isLoggedIn ? (
        <>
          <Route path="/products" element={<Product />} />
          <Route path="/orders" element={<Order />} />
          <Route path="/account" element={<Account />} />
          <Route path="/" element={<Account />} />
        </>
      ) : (
        <>
          <Route path="/account" element={<Account />} />
          <Route path="/" element={<Account />} />
        </>
      )}
    </ReactRoutes>
  );
}

export default Routes;
